import { Button, Form, Input, Tooltip, TreeSelect } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import PolicyService from '../../../../../services/Policy.service';
import { IconMoveNoBg } from '../../../../workflow/WorkflowDetail/Dnd/iconMove';
import { IconDelete } from './IconDelete';
import { InfoCircleOutlined } from '@ant-design/icons';

const PersonalData = (props) => {
    const { t } = useTranslation();
    const [selectedValues, setSelectedValues] = useState([]);
    const [personalDataOptionList, setPersonalDataOption] = useState([]);
    const [personalAddOn, setPersonalAddOn] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const personalDataOption =
        Form.useWatch('personalDataOption', props?.form) ?? [];

    const personalDataOptionSequence =
        Form.useWatch('personalDataOptionSequence', props?.form) ?? [];

    useEffect(() => {
        const getPersonalDataOption = async () => {
            const { data } = await PolicyService.getPersonalDataOption();
            if (data.resultData) {
                setPersonalDataOption(data.resultData);
            }
        };
        getPersonalDataOption();
    }, []);

    const value = personalDataOptionList?.map((x) => {
        return {
            title: x.personalDataOptionTh,
            value: x.personalDataOptionId,
        };
    });

    const allIds = value.map(({ value }) => value);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragPersonalEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const newItems = reorder(
            personalDataOptionSequence,
            result.source.index,
            result.destination.index
        );
        props.form.setFieldsValue({ personalDataOptionSequence: newItems });
    };

    const generateObj = (triggerValue) => {
        let personal_ = [];
        personal_ = personalDataOptionList.filter(
            (option) => triggerValue === option.personalDataOptionId
        );
        personal_ = personal_.map((item) => {
            return {
                personDataOptionId: item.personalDataOptionId,
                personDataOptionNameTh: item?.personalDataOptionTh,
                personDataOptionNameEn: item?.personalDataOptionEn ?? '',
                isAddOn: false,
            };
        });
        return personal_[0];
    };

    const generateObjAddOn = (value) => {
        return {
            personDataOptionId: moment().valueOf().toString(),
            personDataOptionNameTh: value,
            personDataOptionNameEn: '',
            isAddOn: true,
        };
    };

    const onChangePersonalData = (ids, _, { checked, triggerValue }) => {
        setSelectedValues(ids);
        if (checked) {
            props.form.setFieldsValue({
                personalDataOptionSequence: [
                    ...personalDataOptionSequence,
                    generateObj(triggerValue),
                ],
            });
        }
        if (!checked) {
            props.form.setFieldsValue({
                personalDataOptionSequence: personalDataOptionSequence.filter(
                    (item) =>
                        item.personDataOptionId !==
                        generateObj(triggerValue).personDataOptionId
                ),
            });
        }
    };

    const oonSelectAllPersonalData = () => {
        setSelectedValues(allIds);
        const arr2 = personalDataOptionSequence.map(
            (is) => is.personDataOptionId
        );
        props.form.setFieldsValue({
            personalDataOption: allIds,
        });
        let temp1 = allIds.filter((value) => !arr2.includes(value));
        let personal_ = [];
        personal_ = personalDataOptionList.filter((option) =>
            temp1.includes(option.personalDataOptionId)
        );
        personal_ = personal_.map((item) => {
            return {
                personDataOptionId: item.personalDataOptionId,
                personDataOptionNameTh: item?.personalDataOptionTh,
                personDataOptionNameEn: item?.personalDataOptionEn ?? '',
                isAddOn: false,
            };
        });
        props.form.setFieldsValue({
            personalDataOptionSequence: [
                ...personalDataOptionSequence,
                ...personal_,
            ],
        });
    };

    const onUnSelectAllPersonalData = () => {
        setSelectedValues([]);
        props.form.setFieldsValue({
            personalDataOption: [],
        });
        props.form.setFieldsValue({
            personalDataOptionSequence: personalDataOptionSequence.filter(
                (is) => is.isAddOn
            ),
        });
    };

    const onAddPersonalSequence = (e) => {
        if (personalAddOn) {
            const duplicate = personalDataOptionSequence?.find(
                (d) => d.personDataOptionNameTh === personalAddOn
            );
            if (duplicate) {
                setError(true);
                setErrorMessage('Duplicate Personal Data');
            } else {
                props.form.setFieldsValue({
                    personalDataOptionSequence: [
                        ...personalDataOptionSequence,
                        generateObjAddOn(personalAddOn),
                    ],
                });
                setPersonalAddOn('');
                setError(false);
            }
        }
        e.preventDefault();
    };

    const removeItem = (id) => {
        props.form.setFieldsValue({
            personalDataOptionSequence: personalDataOptionSequence.filter(
                (item) => item.personDataOptionId !== id
            ),
            personalDataOption: personalDataOption.filter(
                (item) => item !== id
            ),
        });
        setSelectedValues(selectedValues.filter((item) => item !== id));
    };

    const removeItemAddOn = (value) => {
        props.form.setFieldsValue({
            personalDataOptionSequence: personalDataOptionSequence.filter(
                (item) => item.personDataOptionNameTh !== value
            ),
        });
    };

    return (
        <div style={{ background: '#F4F6FC' }} className="p-4 rounded-md mt-4">
            <span className="ant-col ant-form-item-label">
                <label>
                    <span className="text-base font-semibold">
                        {t('policy.personalDataOption')} (
                        {t('TotalItems', {
                            length: personalDataOptionSequence?.length,
                        })}
                        )
                    </span>
                </label>
            </span>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="text-sm font-semibold">
                        {t('policy.SpecifyPersonalData')}
                    </label>
                    <Form.Item
                        name="personalDataOption"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: t('errorText.requiredField'),
                        //     },
                        // ]}
                    >
                        <TreeSelect
                            treeCheckable
                            className="tree_ mt-2"
                            size="large"
                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                            onChange={onChangePersonalData}
                            placeholder={t('policy.SelectPersonalData')}
                            showSearch={false}
                            maxTagCount={0}
                            maxTagPlaceholder={(omittedValues) =>
                                // `เลือกทั้งหมด ${omittedValues.length} รายการ`
                                `${t('policy.SelectTotalItems', {
                                    length: omittedValues.length,
                                })}`
                            }
                            treeData={[
                                {
                                    title:
                                        selectedValues.length ===
                                        value.length ? (
                                            <button
                                                type="button"
                                                onClick={
                                                    onUnSelectAllPersonalData
                                                }
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('dataFlow.UnselectAll')}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={
                                                    oonSelectAllPersonalData
                                                }
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('RoPA.SelectAll')}
                                            </button>
                                        ),
                                    value: 'xxx',
                                    disableCheckbox: true,
                                    disabled: true,
                                    checkable: false,
                                },
                                ...value,
                            ]}
                        />
                    </Form.Item>
                </div>
                <div>
                    <label className="text-sm font-semibold">
                        {t('policy.CreateAdditionalPersonalData')}
                    </label>
                    <Form.Item
                        help={error && errorMessage}
                        validateStatus={error && 'error'}
                    >
                        <div className="flex space-x-2 items-center pt-2">
                            <Input
                                onChange={(e) => {
                                    setPersonalAddOn(e.target.value);
                                    if (e.target.value.length > 300) {
                                        setError(true);
                                        setErrorMessage(
                                            t(
                                                'This field must be between 1 and 300 characters'
                                            )
                                        );
                                    } else setError(false);
                                }}
                                value={personalAddOn}
                                size="large"
                                className="bg-white"
                                placeholder={t('policy.AddExampleData')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onAddPersonalSequence(e);
                                    }
                                }}
                                // maxLength={300}
                                // showCount
                            />
                            <Button
                                disabled={error}
                                onClick={onAddPersonalSequence}
                                size="large"
                                type="primary"
                            >
                                {t('common.Add')}
                            </Button>
                        </div>
                    </Form.Item>
                </div>
            </div>

            <Form.List name="personalDataOptionSequence">
                {(fields) => (
                    <DragDropContext onDragEnd={onDragPersonalEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div ref={provided.innerRef}>
                                    {personalDataOptionSequence?.map(
                                        (item, index) => (
                                            <Draggable
                                                key={item.personDataOptionId}
                                                draggableId={
                                                    item.personDataOptionId
                                                }
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <>
                                                        <div
                                                            ref={
                                                                provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={classNames(
                                                                'rounded-md flex justify-between items-center p-4 pr-1 mb-2 h-10 text-sm font-medium cursor-default pl-10 relative bg-white',
                                                                {
                                                                    'bg-purple-light':
                                                                        item.isAddOn,
                                                                }
                                                            )}
                                                        >
                                                            <div className="flex items-center">
                                                                <div className="absolute left-4 top-2">
                                                                    <IconMoveNoBg />
                                                                </div>
                                                                <span>
                                                                    {
                                                                        item.personDataOptionNameTh
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="flex items-center space-x-2">
                                                                <Tooltip title="ข้อมูลส่วนบุคคลเพิ่มเติม">
                                                                    <InfoCircleOutlined
                                                                        className="text-purple text-lg cursor-default"
                                                                        hidden={
                                                                            !item.isAddOn
                                                                        }
                                                                    />
                                                                </Tooltip>
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        item.isAddOn
                                                                            ? removeItemAddOn(
                                                                                  item.personDataOptionNameTh
                                                                              )
                                                                            : removeItem(
                                                                                  item.personDataOptionId
                                                                              )
                                                                    }
                                                                    className="flex items-center"
                                                                >
                                                                    <IconDelete />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {provided.placeholder}
                                                    </>
                                                )}
                                            </Draggable>
                                        )
                                    )}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                )}
            </Form.List>
        </div>
    );
};

export default PersonalData;
